import { Injectable } from '@angular/core';
import {
  CommissioningGasDeviceTypeConstant,
  CommissioningPowerDeviceTypeConstant,
  CommissioningPowerHeatingUseConstant,
  CommissioningPowerHeatSourceTypeConstant,
  CommissioningPowerLocationTypeConstant,
  CommissioningPowerObjectTypeTypeConstant,
  CommissioningPowerOperationalModeTypeConstant,
  CommissioningPowerPumpTypeTypeConstant
} from '@bo-client/activation-management/shared/commissioning-constans';
import {
  ActionTypeEnum,
  CommissioningPowerFixingType
} from '@bo-client/activation-management/shared/models/commissioningModel';
import {
  CommissioningDistrictHeatActionTypeEnum,
  CommissioningGasActionTypeEnum,
  CommissioningPowerActionTypeEnum,
  CommissioningWaterActionTypeEnum
} from '@bo-client/activation-management/commissioning/forms/commissioning-data-enum';

@Injectable({
  providedIn: 'root'
})
export class CommissioningDataService {
  commissioningPowerActionType = CommissioningPowerActionTypeEnum;

  commissioningGasActionType = CommissioningGasActionTypeEnum;

  commissioningDistrictHeatActionType = CommissioningDistrictHeatActionTypeEnum;

  commissioningWaterActionType = CommissioningWaterActionTypeEnum;

  commissioningPowerFixingType = [
    {
      value: CommissioningPowerFixingType.OnePoint,
      displayName: 'Steckbefestigung eHZ'
    },
    {
      value: CommissioningPowerFixingType.Three,
      displayName: 'Dreipunktbefestigung'
    },
    {
      value: CommissioningPowerFixingType.Unnecessary,
      displayName: 'Nicht notwendig'
    }
  ];

  commissioningPowerCurrentPowerType = [
    {
      value: 'smaller_1A',
      displayName: '<=1 A'
    },
    {
      value: 'smaller_5A',
      displayName: '<=5 A'
    },
    {
      value: 'smaller_60A',
      displayName: '<=60 A'
    },
    {
      value: 'smaller_100A',
      displayName: '<=100 A'
    }
  ];

  commissioningPowerFuseAmpType = [
    {
      value: 35,
      displayName: '35 A'
    },
    {
      value: 50,
      displayName: '50 A'
    },
    {
      value: 63,
      displayName: '63 A'
    }
  ];

  commissioningPowerOperationType = [
    {
      value: 'continuousOperation',
      displayName: 'Dauerbetrieb'
    },
    {
      value: 'intermittentOperation',
      displayName: 'Aussetzbetrieb'
    }
  ];

  CommissioningDistrictHeatingActionType = [
    {
      value: 'oil',
      displayName: 'Öl'
    },
    {
      value: 'gas',
      displayName: 'Gas'
    },
    {
      value: 'others',
      displayName: 'Sonstige'
    }
  ];

  commissioningPowerFacilityType = [
    {
      value: 'ConstructionSite',
      displayName: 'Baustelle (zeitl. befristet)'
    },
    {
      value: 'Flat',
      displayName: 'Wohnung'
    },
    {
      value: 'House',
      displayName: 'Haus'
    },
    {
      value: 'Business',
      displayName: 'Gewerbe'
    },
    {
      value: 'CommunityFacilities',
      displayName: 'Gemeinschaftsanlagen'
    },
    {
      value: 'Others',
      displayName: 'Sonstiges'
    }
  ];

  commissioningTariffControlType = [
    {
      value: 'Required',
      displayName: 'Es wird ein Tarifsteuergerät benötigt'
    },
    {
      value: 'AlreadyAvailable',
      displayName: 'Es ist bereits ein Tarifsteuergerät vorhanden'
    },
    {
      value: 'Removed',
      displayName: 'Das vorhandene Tarifsteuergerät wird ausgebaut'
    }
  ];

  public getCommissioningPowerFixingType() {
    return this.commissioningPowerFixingType;
  }

  public getCommissioningDistrictHeatingActionType() {
    return this.CommissioningDistrictHeatingActionType;
  }

  public getCommissioningPowerFacilityType() {
    return this.commissioningPowerFacilityType;
  }

  public getCommissioningPowerDeviceType() {
    return CommissioningPowerDeviceTypeConstant;
  }

  public getCommissioninggasDeviceType() {
    return CommissioningGasDeviceTypeConstant;
  }

  public getCommissioningPowerLocationType() {
    return CommissioningPowerLocationTypeConstant;
  }

  public getCommissioningPowerPumpTypeType() {
    return CommissioningPowerPumpTypeTypeConstant;
  }

  public getCommissioningPowerOperationalModeType() {
    return CommissioningPowerOperationalModeTypeConstant;
  }

  public getCommissioningPowerHeatSourceType() {
    return CommissioningPowerHeatSourceTypeConstant;
  }

  public getCommissioningPowerObjectTypeType() {
    return CommissioningPowerObjectTypeTypeConstant;
  }

  public getCommissioningPowerHeatingUseConstant() {
    return CommissioningPowerHeatingUseConstant;
  }
}
